import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { SharedModule } from '../../shared.module';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  standalone: true,
  selector: 'app-image-modal',
  templateUrl: './image-modal.component.html',
  styleUrls: ['./image-modal.component.scss'],
  imports: [CommonModule, MatDialogModule, SharedModule, MatIconModule]
})
export class ImageModalComponent {
  currentIndex: number = 0;

  constructor(
    public dialogRef: MatDialogRef<ImageModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { images: string[]; selectedIndex: number }
  ) {
    this.currentIndex = data.selectedIndex ?? 0;
  }

  close(): void {
    this.dialogRef.close();
  }

  prevImg(): void {
    if (!this.data.images?.length) return;

    this.currentIndex =
      this.currentIndex === 0
        ? this.data.images.length - 1
        : this.currentIndex - 1;
  }

  nextImg(): void {
    if (!this.data.images?.length) return;

    this.currentIndex =
      this.currentIndex === this.data.images.length - 1
        ? 0
        : this.currentIndex + 1;
  }
}
